import { getWorkstationUrl } from '../workstationUrl'

type Props = {
  /** 展示用短名，如「管仲·财务台」「天工·统管台」 */
  workstationDisplayName: string
}

/**
 * 无本工作台入口（visible_workbenches 未包含）时的全屏说明，并链回秘书台门户。
 * 不依赖 icon 库，供各 Vite 工作台复用。
 */
export function WorkbenchAccessDeniedPage({ workstationDisplayName }: Props) {
  const portalHref = `${getWorkstationUrl('secretary')}#/portal`
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
      <div className="text-4xl" aria-hidden>
        ⚠️
      </div>
      <h1 className="text-lg font-semibold text-slate-900">无「{workstationDisplayName}」访问权限</h1>
      <p className="max-w-md text-sm text-slate-600">
        当前账号未被分配进入该工作台的角色或权限，无法使用本应用。如需访问，请在治理台由管理员为您分配对应工作台角色或菜单权限。
      </p>
      <a
        href={portalHref}
        className="rounded-lg bg-sky-600 px-4 py-2 text-sm font-medium text-white hover:bg-sky-700"
      >
        返回秘书台工作台门户
      </a>
    </div>
  )
}
